export const BannerPageConstants = [
    // {id: 1, name: 'Trang chủ' },
    { id: 2, name: 'Mentor' },
    { id: 3, name: 'Cẩm nang sinh viên' },
    { id: 4, name: 'Cẩm nang sự nghiệp' },
    { id: 5, name: 'Tìm việc' },
    { id: 6, name: 'Hoạt động' },
    { id: 7, name: 'Kiếm xu' },
    { id: 28, name: 'Khoá học chi tiết' },
]

export const BannerPositionConstants = [
    { id: 'bottom', name: 'Bên dưới' },
    { id: 'sidebar', name: 'Bên phải' },
]

export const BannerWebPageConstants = [
    { id: 1, name: 'Trang chủ' },
    { id: 2, name: 'Mentor' },
    { id: 5, name: 'Tìm việc' },
    { id: 7, name: 'Kiếm xu' },
    { id: 27, name: 'Về chúng tôi' },
    { id: 8, name: 'Review trường' },
    { id: 9, name: 'Tài liệu học tập' },
    { id: 10, name: 'Thông báo tuyển sinh' },
    { id: 11, name: 'Thông báo chuẩn đầu ra' },
    { id: 12, name: 'Ôn thi học kỳ' },
    { id: 13, name: 'Tiếng anh' },
    { id: 14, name: 'Tiếng trung' },
    { id: 15, name: 'Tin học' },
    { id: 16, name: 'Lộ trình nghề nghiệp' },
    { id: 17, name: 'Công cụ định hướng bản thân' },
    { id: 18, name: 'Công cụ đánh giá công việc' },
    { id: 19, name: 'Kỹ năng mềm' },
    { id: 20, name: 'Kỹ năng chuyên môn' },
    { id: 21, name: 'Tài liệu công việc' },
    { id: 22, name: 'Câu lạc bộ' },
    { id: 23, name: 'Dự án' },
    { id: 24, name: 'Cuộc thi' },
    { id: 25, name: 'Học bổng' },
    { id: 26, name: 'Sự kiện' },
]

export const PriorityListConstant = [
    { id: 1, name: 'Ưu tiên' },
    { id: 0, name: 'Không ưu tiên' },
]